module.exports = __webpack_public_path__ + "img/light-Path 21 Copy@3x.ab27d760.png";